// biome-ignore lint/style/noRestrictedImports: encapsulation
import { ceil as ceil_ } from "remeda";

import { unpurry } from "./_unpurry";

export const ceil = unpurry(ceil_, 2);
